import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

//Common
import { ID_PARAMETRIZACAO, TELAS } from "@/common/constantes";

//Util
import { ICONES_BOTAO, ICONES_MENSAGEM } from "@/frontend/utils/icones";
import {
  VERSAO_ATUAL,
  fn_formatarVersao,
  fn_getVersaoVistaAdm,
  fn_mostrarAvisoVersaoAdm,
  fn_salvarVersaoVistaAdm,
} from "@/frontend/utils/versao";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

/*
 * Aviso de nova versão publicada no SIIG Administrativo (usado no cabeçalho, só no Administrativo).
 * Aparece uma vez por navegador para cada versão nova, com o botão para ver o changelog.
 * Liga e desliga pelo parâmetro global AVISO_NOVA_VERSAO_ADM_SYSTEM (valor_padrao "S" = ligado; "N" = desligado).
 */
export default function AvisoVersaoAdm() {
  const navigate = useNavigate();

  //### USE STATE ###
  const [modalOpen, setModalOpen] = useState(false);

  //### USE EFFECT ###
  //Inicialização: confere se o aviso está ligado e se a versão ainda não foi vista neste navegador
  useEffect(() => {
    async function verificarAviso() {
      //Já foi vista: não precisa consultar o parâmetro
      if (VERSAO_ATUAL == fn_getVersaoVistaAdm()) {
        return;
      }

      const parametrizacoes = await api_listar(
        ROTA_LISTAR.PARAMETRIZACAO,
        "situacao=A",
      );
      const param = (parametrizacoes || []).find(
        (item) => item.id == ID_PARAMETRIZACAO.AVISO_NOVA_VERSAO_ADM_SYSTEM,
      );

      //Sem o parâmetro no banco o aviso fica ligado, que é o valor padrão
      const avisoLigado = (param?.valor_padrao ?? "S") == "S";

      if (
        fn_mostrarAvisoVersaoAdm(
          avisoLigado,
          VERSAO_ATUAL,
          fn_getVersaoVistaAdm(),
        )
      ) {
        setModalOpen(true);
      }
    }

    verificarAviso();
  }, []);

  //### EVENTOS ###
  //OnClick - Botão Ciente
  function handleBotaoCiente() {
    fn_salvarVersaoVistaAdm(VERSAO_ATUAL);
    setModalOpen(false);
  }

  //OnClick - Botão Ver o que mudou: abre a consulta do changelog, que mostra a versão mais nova
  function handleBotaoVerChangelog() {
    fn_salvarVersaoVistaAdm(VERSAO_ATUAL);
    setModalOpen(false);
    navigate(TELAS.SYS_CHANGELOG.rota);
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static" centered>
      <ModalHeader toggle={handleBotaoCiente} className="titulo-tela-modal">
        {ICONES_MENSAGEM.INFO} Nova versão publicada
      </ModalHeader>

      <ModalBody>
        <div className="mb-2">
          O SIIG foi atualizado para a versão{" "}
          <strong>{fn_formatarVersao(VERSAO_ATUAL)}</strong>.
        </div>
        <div>Veja o que mudou nesta versão na consulta do Changelog.</div>
      </ModalBody>

      <ModalFooter>
        <Button
          name="btnVerChangelog"
          color="primary"
          onClick={handleBotaoVerChangelog}
        >
          {ICONES_BOTAO.VISUALIZAR} Ver o que mudou
        </Button>
        <Button name="btnCiente" color="secondary" onClick={handleBotaoCiente}>
          {ICONES_BOTAO.CONFIRMAR} Ciente
        </Button>
      </ModalFooter>
    </Modal>
  );
}
